import { render, staticRenderFns } from "./FiltersPopupHierarchyItems.vue?vue&type=template&id=06ce1704&scoped=true"
import script from "./FiltersPopupHierarchyItems.vue?vue&type=script&lang=js"
export * from "./FiltersPopupHierarchyItems.vue?vue&type=script&lang=js"
import style0 from "./FiltersPopupHierarchyItems.vue?vue&type=style&index=0&id=06ce1704&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ce1704",
  null
  
)

export default component.exports